import React from "react";
import SalesBox$ from "@deosite/components-new/SalesBox";

const SalesBox = props => <SalesBox$ {...props} />;

export default SalesBox;
